import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { indexOf } from 'lodash';
import { environment } from '../../../../../../../../environments/environment';


@Component({
  selector: 'tab-permissions',
  templateUrl: './tab-permissions.component.html',
  styleUrls: ['./tab-permissions.component.scss']
})
export class TabPermissionsComponent implements OnInit {
  @Input() public categoriesArray: FormArray;
  @Input() public isViewMode: boolean;

  private currentlyExpandedCategoryIndex = null;
  public isProduction = environment.production;

  constructor(private readonly authenticationService: AuthenticationService) { }

  async ngOnInit(): Promise<void> {
    this.categoriesArray.controls.forEach((category) => {
      this.onPermissionSelectionChange(category);
    });
  }

  public switchCategoryExpansion(category: any): void {
    const newExpandedValue = !category.get('expanded').value;
    category.get('expanded').setValue(newExpandedValue);

    if (newExpandedValue) {
      if (this.currentlyExpandedCategoryIndex !== null) {
        this.categoriesArray.at(this.currentlyExpandedCategoryIndex).get('expanded').setValue(false);
      }
      this.currentlyExpandedCategoryIndex = indexOf(this.categoriesArray.controls, category);
    } else {
      this.currentlyExpandedCategoryIndex = null;
    }
  }

  public onCategorySelectionChange(checked, category): void {
    category.get('indeterminate').setValue(false);
    category.get('permissions').controls.forEach((permission) => {
      permission.get('checked').setValue(checked);
    });
  }

  public onPermissionSelectionChange(category): void {
    const permissionLength = category.get('permissions').controls.length;
    const checkedPermissionsCount = category
      .get('permissions')
      .controls.filter((permission) => permission.get('checked').value).length;

    const checked = permissionLength === checkedPermissionsCount;
    const indeterminate = !checked && checkedPermissionsCount > 0;
    category.get('checked').setValue(checked);
    category.get('indeterminate').setValue(indeterminate);
  }

  public toggleCategory(category: any): void {
    const newCheckedValue = !category.get('checked').value;
    category.get('checked').setValue(newCheckedValue);
    this.onCategorySelectionChange(newCheckedValue, category);
  }

  public togglePermission(category: any, permission: any): void {
    const newCheckedValue = !permission.get('checked').value;
    permission.get('checked').setValue(newCheckedValue);
    this.onPermissionSelectionChange(category);
  }

  public isVisiblePermissionCategory(category: FormGroup): boolean {
    const value = category.getRawValue();
    if (!value.featureFlag) { return true; }
    return this.authenticationService.hasFlags(value.featureFlag);
  }
}
